<template>
  <div class="prize column-me" :class="{'mobile-mode': isMobile}">
    <!-- Banner -->
    <div class="banner-section column-me center-all">
      <div class="section-content">
        <div class="banner-item">
          <img src="../../assets/img/about/bg_about1.jpg" class="banner-bg" draggable="false">
          <div class="banner-content" v-if="!isMobile">
            <div v-if="nowLanguage==='zh-cn'||nowLanguage==='ja'">
              <img src="../../assets/img/about/about_title3.png" class="w1000 h400 objScaleDown" draggable="false">
            </div>
            <div v-else>
              <img src="../../assets/img/home/home_title13.png" class="w580 objContain" draggable="false">
            </div>
          </div>
          <div class="banner-content font-n" v-if="isMobile">
            <img src="../../assets/img/home/home_title_m_w.png" class="w380 objContain" draggable="false">
            <div class="font36 font-l mT10" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              悦唯所至 繁复皆<span class="colorOrange">简</span>
            </div>
            <img src="../../assets/img/go.png" class="img70 objFitCover mT40" draggable="false">
          </div>
        </div>
      </div>
    </div>

    <!-- 关于我们内容 -->
    <div class="prize-content column-me center-all">
      <img src="../../assets/img/about/prize.png" class="img-prize objScaleDown scroll-bounce" draggable="false"
           v-if="!isMobile" ref="prizeIcon">
      <div class="column-me row-center pB50">
        <div class="w1000">
          <!-- 手机端标题 -->
          <div class="row-me scroll-fade" v-if="isMobile" ref="mobileTitle">
            <div class="column-me mT20">
              <img src="../../assets/img/about/prize.png" class="img45 objContain" draggable="false">
              <div class="font36 font-db mT15">{{ $t('prize.title') }}</div>
            </div>
            <div class="flex1"></div>
            <img src="../../assets/img/about/awards.png" class="w240 objContain" draggable="false">
          </div>
          <!-- PC端标题 -->
          <div class="row-me row-center mT120 scroll-fade" v-if="!isMobile" ref="pcTitle">
            <img src="../../assets/img/home/go.png" class="img30 objScaleDown" draggable="false">
            <div class="font24 colorBlue mL10">{{ $t('prize.title') }}</div>
          </div>

          <!-- 奖项列表 -->
          <div class="row-me flex-wrap" ref="prizeList">
            <template v-for="(item, index) in prizeList" :key="index">
              <!-- 文字奖项 -->
              <div class="row-me mT50 prize-item"
                   :class="isMobile ? 'scroll-fade' : 'scroll-slide-left'"
                   v-if="!item.isImageOnly" :style="{ transitionDelay: (index * 0.15) + 's' }">
                <div class="number-div">{{ (index + 1) < 10 ? '0' + (index + 1) : index + 1 }}</div>
                <div class="flex1 column-me colorBlue mL50">
                  <div class="font48">{{ item.awardTime }}</div>
                  <div class="font30 mT10">{{ item.title }}</div>
                </div>
              </div>
              <!-- 图片奖项 -->
              <div class="row-me mT50 scroll-fade prize-images-row"
                   v-else :style="{ animationDelay: (index * 0.15) + 's' }">
                <div class="number-div mR50">{{ (index + 1) < 10 ? '0' + (index + 1) : index + 1 }}</div>
                <div class="flex1 h200 mR50 mRLast0 prize-image scroll-zoom"
                     v-for="(item1, index1) in item.images" :key="index1"
                     :style="{ animationDelay: (0.3 + index1 * 0.1) + 's' }">
                  <div class="column-me row-center">
                    <el-image :src="item1" :preview-src-list="item.images" fit="contain" class="wh100Per img-p"
                              hide-on-click-modal preview-teleported :initial-index="index">
                      <template #error>
                        <img src="../../assets/img/error.png" class="wh100Per objFitCover" draggable="false">
                      </template>
                    </el-image>
                    <div class="row-me center-all mT15" v-if="isMobile">
                      <div class="font14 font-m">{{ $t('prize.viewDetails') }}</div>
                      <img src="../../assets/img/about/r.png" class="img10 mL10 objContain" draggable="false">
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- 手机端底部按钮 -->
          <div class="row-me flex-end1 mB30 mT60 scroll-fade" v-if="isMobile" ref="mobileBtn">
            <div class="btn-go pointer row-me center-all" @click="clickAbout">
              <div class="font21 font-n">{{ $t('about.aboutYuewei') }}</div>
              <img src="../../assets/img/go.png" class="img30 objContain mL10" draggable="false">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {deviceState} from "@/utils/device";
import {getAboutAwards, parseImages} from "@/http/api";
import bus from "@/assets/js/bus";
import {getLanguage} from "../../i18n";

export default {
  data() {
    return {
      deviceState,
      observer: null,
      // 默认静态数据
      defaultPrizeList: [
        {
          "id": 1,
          "awardType": 1,
          "awardTime": "2021年",
          "title": "国家高新技术企业",
          "images": [],
          "isImageOnly": false
        },
        {
          "id": 2,
          "awardType": 1,
          "awardTime": "2021年",
          "title": "国家高新技术企业",
          "images": [],
          "isImageOnly": false
        },
        {
          "id": 3,
          "awardType": 1,
          "awardTime": "2021年",
          "title": "国家高新技术企业",
          "images": [],
          "isImageOnly": false
        },
        {
          "id": 4,
          "awardType": 2,
          "awardTime": null,
          "title": null,
          "images": [
            require("../../assets/img/about/prize1.png"),
            require("../../assets/img/about/prize2.png"),
            require("../../assets/img/about/prize3.png"),
          ],
          "isImageOnly": true
        }
      ],
      // API返回的奖项数据
      apiPrizeList: [],
      nowLanguage: '',
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    },
    // 奖项列表 - 优先使用API数据
    prizeList() {
      if (this.apiPrizeList && this.apiPrizeList.length > 0) {
        return this.apiPrizeList
      }
      return this.defaultPrizeList
    }
  },
  created() {
    // 数据加载移到 activated 中，避免首次进入时重复调用
  },
  mounted() {
    this.nowLanguage = getLanguage()
    this.initScrollAnimation()
    // 监听语言切换事件
    bus.$on('language-changed', this.onLanguageChanged)
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    bus.$off('language-changed', this.onLanguageChanged)
  },
  activated() {
    // 页面重新激活时重新加载数据和动画
    this.loadAwards()
    this.$nextTick(() => {
      this.resetAnimations()
    })
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      this.nowLanguage = getLanguage()
      this.loadAwards()
    },
    // 加载获奖与称号数据
    async loadAwards() {
      try {
        const res = await getAboutAwards()
        if (res && res.code === 200 && res.data) {
          this.apiPrizeList = res.data.map(item => ({
            id: item.id,
            awardType: item.awardType,
            awardTime: item.awardTime,
            title: item.title,
            images: parseImages(item.images),
            isImageOnly: item.isImageOnly
          }))
          // 数据加载完成后，重新初始化动画观察器（因为DOM已重新渲染）
          this.$nextTick(() => {
            this.reinitAnimationObserver()
          })
        }
      } catch (error) {
        console.error('加载获奖与称号失败:', error)
      }
    },
    clickAbout() {
      this.$router.push({
        path: '/aboutUs',
        query: {}
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.1,
        rootMargin: '0px 0px -80px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
            // 一旦动画触发，停止观察该元素
            this.observer.unobserve(entry.target)
          }
        })
      }, options)

      // 延迟一帧确保 DOM 已渲染
      this.$nextTick(() => {
        // 观察所有需要动画的元素
        const animateElements = this.$el.querySelectorAll('.scroll-fade, .scroll-slide-left, .scroll-zoom, .scroll-bounce')
        animateElements.forEach(el => {
          this.observer.observe(el)
        })
      })
    },
    // 重置所有动画
    resetAnimations() {
      const animateElements = this.$el.querySelectorAll('.scroll-fade, .scroll-slide-left, .scroll-zoom, .scroll-bounce')
      animateElements.forEach(el => {
        el.classList.remove('animate-in')
      })

      // 重新观察所有元素
      this.$nextTick(() => {
        animateElements.forEach(el => {
          if (this.observer) {
            this.observer.observe(el)
          }
        })
      })
    },
    // 重新初始化动画观察器（用于数据加载后DOM重新渲染的情况）
    reinitAnimationObserver() {
      // 观察所有需要动画的元素
      const animateElements = this.$el.querySelectorAll('.scroll-fade, .scroll-slide-left, .scroll-zoom, .scroll-bounce')
      animateElements.forEach(el => {
        if (this.observer) {
          this.observer.observe(el)
        }
      })
      // 立即检查可见元素并触发动画
      this.checkVisibleElements()
    },
    // 检查当前可见的元素并立即触发动画
    checkVisibleElements() {
      const animateElements = this.$el.querySelectorAll('.scroll-fade, .scroll-slide-left, .scroll-zoom, .scroll-bounce')
      const windowHeight = window.innerHeight || document.documentElement.clientHeight

      animateElements.forEach(el => {
        const rect = el.getBoundingClientRect()
        // 如果元素在视口中，立即触发动画
        if (rect.top < windowHeight * 0.9 && rect.bottom > 0) {
          el.classList.add('animate-in')
          // 已触发动画的元素停止观察
          if (this.observer) {
            this.observer.unobserve(el)
          }
        }
      })
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path === '/prize' && from && from.path !== '/prize') {
          this.$nextTick(() => {
            window.scrollTo({top: 0, behavior: 'smooth'})
            this.resetAnimations()
          })
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.prize {
  width: 100%;
  scroll-behavior: smooth;

  .img-p {
    border: 2px solid #EE7D32;
  }

  .btn-go {
    padding: 10px 15px;
    background: #EDEDF1;
    border-radius: 50px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  .prize-content {
    height: auto;
    background-image: url('../../assets/img/about/bg_prize.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;

    .img-prize {
      width: 110px;
      height: 136px;
      position: absolute;
      top: 0;
      right: 25%;
    }

    .number-div {
      width: 44px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #EB8063;
      border-radius: 17px 17px 17px 17px;
      font-size: 20px;
      color: #FFFFFF;
      margin-top: 15px;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .prize-item {
      min-width: 50%;
    }

    // 奖项项悬停效果
    .prize-item:hover .number-div {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(235, 128, 99, 0.4);
    }
  }
}

// ==================== 滚动动画样式 ====================

// 淡入动画
.scroll-fade {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 从左滑入动画
.scroll-slide-left {
  opacity: 0;
  transform: translateX(-60px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateX(0);
  }
}

// 缩放淡入动画
.scroll-zoom {
  opacity: 0;
  transform: scale(0.85);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  &.animate-in {
    opacity: 1;
    transform: scale(1);
  }

  &:hover {
    transform: scale(1.03);
    transition: transform 0.3s ease;
  }
}

// 弹跳动画
.scroll-bounce {
  opacity: 0;
  transform: translateY(-40px) scale(0.8);
  transition: opacity 0.6s ease-out, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);

  &.animate-in {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

// Banner 进入动画
.banner-section {
  .banner-content {
    animation: fadeInUp 1.2s ease-out 0.3s both;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// ==================== 手机端适配样式 ====================
.prize.mobile-mode {
  color: #454F5E !important;

  .colorBlue {
    color: #454F5E !important;
  }

  // Banner 适配 - 与首页保持一致
  .banner-section {
    .section-content {
      width: 100% !important;
      padding: 0 !important;
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 1020px;
      aspect-ratio: 16 / 9;
      overflow: hidden;

      .banner-bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .banner-content {
        position: absolute;
        top: 25%;
        left: 8%;
        display: flex;
        flex-direction: column;
        font-size: 87px;
        line-height: 80px;
        color: #FFFFFF;
      }
    }
  }

  // 奖项内容区适配
  .prize-content {
    height: auto !important;
    padding: 20px 60px;
    background-image: url('../../assets/img/about/组 80.png');
    background-size: cover;

    .img-prize {
      width: 60px !important;
      height: 75px !important;
      right: 10% !important;
    }

    .posAbsoluteAll {
      position: relative !important;
      overflow: visible !important;
    }

    .w1000 {
      width: 100% !important;
    }

    // 标题适配
    .row-me.row-center.mT120 {
      .img30 {
        width: 40px !important;
        height: 40px !important;
        object-fit: cover;
      }

      .font24 {
        font-size: 35px !important;
        font-family: font-db, sans-serif;
      }
    }

    .m-prize-item {
      margin-top: 60px !important;
    }

    // 奖项列表适配
    .row-me.mT80, .row-me.mT30 {
      flex-direction: row !important;
      flex-wrap: wrap;

      .flex1 {
        width: 50%;
        flex: none !important;
      }

      .prize-item {
        .number-div {
          width: 30px;
          height: 30px;
          line-height: 30px;
          font-size: 15px;
          border-radius: 12px;
          margin-top: 5px;
        }
      }

      .font48 {
        font-size: 32px !important;
        font-family: font-m, serif;
      }

      .font30 {
        font-size: 22px !important;
        margin-top: 5px !important;
        font-family: font-db, serif;
      }
    }

    // 证书图片适配
    .row-me.mT50 {
      flex-wrap: wrap;

      .h200 {
        height: 160px !important;
      }

      .flex1 {
        flex: 1 !important;
        margin-right: 10px !important;
        margin-bottom: 10px;

        &:nth-child(3n) {
          margin-right: 0 !important;
        }
      }

      .mR70 {
        margin-right: 10px !important;
      }
    }

    .number-div {
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 15px;
      border-radius: 12px;
      margin-top: 5px;
    }

    .mL50 {
      margin-left: 15px !important;
    }

    .mR50 {
      margin-right: 15px !important;
    }

    .font48 {
      font-size: 32px !important;
      font-family: font-m, serif;
    }

    .font30 {
      font-size: 22px !important;
      margin-top: 5px !important;
      font-family: font-db, serif;
    }
  }

  // 手机端动画调整 - 减少动画幅度
  .scroll-fade {
    transform: translateY(20px);
  }

  .scroll-zoom {
    transform: scale(0.9);
  }
}
</style>
